import React, { RefObject, useEffect, useRef, useState } from 'react'
import style from './VoteAddEdit.module.scss'
import sanitiseInput from '@bt-react/libs/sanitiseInput'

interface InputParams {
  key?: number,
  value: string,
  name: string,
  dataBdd?: string,
  maxLength: number,
  placeholder: string,
  onChange: ((e: React.ChangeEvent<HTMLTextAreaElement>, i: number | null) => void)
  className?: string
  index: number | null
}

const AutoHeightTextInput: React.FC<InputParams> = props => {

  const [updatedInputText, setUpdatedInputText] = useState(props.value || '')
  const [cursorPosition, setCursorPosition] = useState(0)
  const inputRef : React.RefObject<HTMLTextAreaElement> = useRef(null)

  useEffect(() => {

    setUpdatedInputText( sanitiseInput( removeNewLines( props.value ) ) )

    if (inputRef !== null ) {
      inputRef.current!.style.height = '5px' // reset the height first so the scrollHeight is accurately recalculated
      inputRef.current!.style.height = `${ inputRef.current!.scrollHeight + 5 }px`

      inputRef.current!.selectionStart = cursorPosition
      inputRef.current!.selectionEnd = cursorPosition
    }

  }, [props.value, updatedInputText, inputRef])

  const handleChange = event => {

    props.onChange(event, props.index)

    setCursorPosition(inputRef.current?.selectionStart ?? 0)
  }

  const preventNewLine = (e: React.KeyboardEvent<HTMLTextAreaElement>) => e.key === 'Enter' && e.preventDefault()
  const removeNewLines = (v: string) => v.replace( /(\r\n)+|\r+|\n+|\t+/, ' ' )

  return  <textarea
    name={props.name}
    ref={inputRef}
    data-bdd={props.dataBdd ?? `${props.name ?? 'generic'}-auto-height-text-area` }
    value={updatedInputText}
    maxLength={props.maxLength}
    className={ style['openquestion-text-area'] }
    placeholder={props.placeholder}
    onChange={handleChange}
    onBlur={handleChange}
    onKeyDown={ e => preventNewLine(e) }
  />
}

export default AutoHeightTextInput
